/**
 * Support KB analytics for GTM (dataLayer), gtag (GA4), and DOM events.
 *
 * Events (dataLayer "event" key):
 * - support_article_view - page load on KB article template; use for "most visited" reports (dimension: support_article_handle).
 * - support_article_still_need_help_click - click anywhere in the "Still need help?" CTA; still_need_help_target classifies the element.
 * - support_article_contact_click - email, contact page, or inline form (existing).
 * - support_search_submit - support home search form; support_search_query, support_search_source: support_home
 *
 * DOM: pvs:support-article-view, pvs:support-still-need-help-click, pvs:support-contact-click, pvs:support-search-submit
 */
(function () {
  if (window.__pvsSupportAnalyticsInit) return;
  window.__pvsSupportAnalyticsInit = true;

  function pushLayer(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function gtagEvent(name, params) {
    if (typeof window.gtag !== 'function') return;
    try {
      window.gtag('event', name, params || {});
    } catch (e) {}
  }

  function articleShell() {
    return document.querySelector('.pvs-kb-article[data-template="support-kb-article"]');
  }

  function articleMetaFromShell(el) {
    if (!el) {
      return {
        support_article_handle: '',
        support_article_title: '',
        support_article_url: '',
        support_article_category: '',
        support_hub_label: '',
        page_path: typeof window.location.pathname === 'string' ? window.location.pathname : '',
      };
    }
    return {
      support_article_handle: el.getAttribute('data-pvs-kb-article-handle') || '',
      support_article_title: el.getAttribute('data-pvs-kb-article-title') || '',
      support_article_url: el.getAttribute('data-pvs-kb-article-url') || '',
      support_article_category: el.getAttribute('data-pvs-kb-article-category') || '',
      support_hub_label: el.getAttribute('data-pvs-kb-hub-label') || '',
      page_path: typeof window.location.pathname === 'string' ? window.location.pathname : '',
    };
  }

  function contextFromCtaRoot(root) {
    var shell = articleShell();
    if (shell) return articleMetaFromShell(shell);
    return {
      support_contact_method: '',
      support_article_handle: root ? root.getAttribute('data-pvs-kb-article-handle') || '' : '',
      support_article_title: root ? root.getAttribute('data-pvs-kb-article-title') || '' : '',
      support_article_url: root ? root.getAttribute('data-pvs-kb-article-url') || '' : '',
      support_article_category: '',
      support_hub_label: '',
      page_path: typeof window.location.pathname === 'string' ? window.location.pathname : '',
    };
  }

  /* 1) Article view - frequency → "most visited" in GA4 explorations by support_article_handle */
  var shellEl = articleShell();
  if (shellEl) {
    var viewPayload = Object.assign({ event: 'support_article_view' }, articleMetaFromShell(shellEl));
    pushLayer(viewPayload);
    gtagEvent('support_article_view', {
      support_article_handle: viewPayload.support_article_handle,
      support_article_title: viewPayload.support_article_title,
      support_article_category: viewPayload.support_article_category,
      support_hub_label: viewPayload.support_hub_label,
      page_path: viewPayload.page_path,
    });
    try {
      document.dispatchEvent(new CustomEvent('pvs:support-article-view', { detail: viewPayload }));
    } catch (e) {}
  }

  function classifyStillHelpClick(target) {
    var t = target;
    if (t && t.nodeType !== 1) t = t.parentElement;
    if (!t || !t.closest) return 'cta_area';
    var contact = t.closest('[data-pvs-kb-contact]');
    if (contact) {
      var m = contact.getAttribute('data-pvs-kb-contact');
      return m && m.length ? m : 'contact';
    }
    if (t.closest('.pvs-kb-contact-form') || t.closest('form.pvs-kb-contact-form')) {
      if (t.closest('button[type="submit"]') || (t.tagName === 'BUTTON' && t.type === 'submit')) return 'form_submit';
      return 'form_field';
    }
    if (t.id === 'kb-still-help-title' || t.closest('#kb-still-help-title')) return 'heading';
    if (t.closest('.kb-cta-reassurance')) return 'reassurance';
    if (t.closest('.kb-cta-body')) return 'body';
    if (t.closest('.kb-cta-actions')) return 'cta_actions';
    return 'cta_area';
  }

  function pushStillNeedHelpClick(rawTarget, ctaRoot) {
    var base = contextFromCtaRoot(ctaRoot);
    var helpTarget = classifyStillHelpClick(rawTarget);
    var payload = Object.assign(
      {
        event: 'support_article_still_need_help_click',
        still_need_help_target: helpTarget,
      },
      base
    );
    pushLayer(payload);
    gtagEvent('support_article_still_need_help_click', {
      still_need_help_target: helpTarget,
      support_article_handle: base.support_article_handle,
      support_article_title: base.support_article_title,
      page_path: base.page_path,
    });
    try {
      document.dispatchEvent(new CustomEvent('pvs:support-still-need-help-click', { detail: payload }));
    } catch (e) {}
  }

  function pushContactEvent(method, root) {
    if (!root) return;
    var base = contextFromCtaRoot(root);
    base.support_contact_method = method;
    var payload = Object.assign({ event: 'support_article_contact_click' }, base);
    pushLayer(payload);
    try {
      document.dispatchEvent(new CustomEvent('pvs:support-contact-click', { detail: payload }));
    } catch (e) {}
    gtagEvent('support_contact_click', {
      support_contact_method: method,
      support_article_handle: base.support_article_handle,
      support_article_title: base.support_article_title,
      page_path: base.page_path,
    });
  }

  document.addEventListener(
    'click',
    function (e) {
      var cta = e.target && e.target.closest ? e.target.closest('.kb-cta') : null;
      if (cta && articleShell()) {
        pushStillNeedHelpClick(e.target, cta);
      }

      var t = e.target && e.target.closest ? e.target.closest('[data-pvs-kb-contact]') : null;
      if (!t) return;
      var root = t.closest('[data-pvs-kb-article-root]');
      if (!root) return;
      var method = t.getAttribute('data-pvs-kb-contact');
      if (method) pushContactEvent(method, root);
    },
    false
  );

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f) return;

    if (f.classList && f.classList.contains('pvs-kb-contact-form')) {
      var root = f.closest('[data-pvs-kb-article-root]');
      if (root) pushContactEvent('form_submit', root);
    }

    if (f.id === 'support-search-form') {
      var q = f.querySelector && f.querySelector('[name="q"]');
      var term = q && q.value != null ? String(q.value).trim() : '';
      var searchPayload = {
        event: 'support_search_submit',
        support_search_query: term,
        support_search_source: 'support_home',
        page_path: typeof window.location.pathname === 'string' ? window.location.pathname : '',
      };
      pushLayer(searchPayload);
      gtagEvent('search', { search_term: term || '(empty)' });
      gtagEvent('support_search_submit', {
        search_term: term,
        support_search_source: 'support_home',
      });
      try {
        document.dispatchEvent(new CustomEvent('pvs:support-search-submit', { detail: searchPayload }));
      } catch (err) {}
    }
  });
})();
